<template>
  <div class="text-center">
    <v-menu
      class="z-20"
      v-model="menu"
      :close-on-content-click="false"
      left
      offset-x
      :nudge-width="200"
      offset-y
    >
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on"
          ><v-icon class="!m-0" color="primary">fas fa-cog</v-icon></v-btn
        >
      </template>

      <v-card>
        <v-list>
          <v-list-item>
            <lang-selector />
          </v-list-item>
        </v-list>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn small color="primary" text @click="menu = false"> Ok </v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>
  </div>
</template>

<script>
import langSelector from "@/components/misc/langSelector.vue";
export default {
  components: { langSelector },
  data: () => ({
    menu: false,
  }),
};
</script>
